import { Clipboard } from '@angular/cdk/clipboard';
import { Component, DOCUMENT, Inject, Input, OnInit } from '@angular/core';

@Component({
  selector: 'portal-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styles: [],
  host: {
    class: 'portal-copy-to-clipboard',
  },
  standalone: false,
})
export class CopyToClipboardComponent implements OnInit {
  @Input()
  text!: string;

  copied: boolean = false;

  copyIcon = '<i class="far fa-copy me-1"></i>';

  constructor(
    private clipboard: Clipboard,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit() {}

  copyToClipboard($event: Event) {
    const selectedText = this.doc.getSelection().toString();
    if (selectedText.length === 0) {
      $event.stopPropagation();
      this.clipboard.copy(this.text);
      this.copied = true;
    }
  }

  mouseLeft($event: Event) {
    $event.stopPropagation();
    if (this.copied === true) {
      setTimeout(() => {
        this.copied = false;
      }, 333);
    }
  }
}
